import { IPromotion } from '../types/village';

const defaultColor = '#ff7e00';

export const getPromotionLabels = (promotions: IPromotion[] | null | undefined) => {
  if (!promotions || !promotions.length) {
    return;
  }

  const { name, color, labelPromoLogoUrl } = promotions[0];

  return [
    {
      title: name,
      color: color || defaultColor,
      icon: labelPromoLogoUrl || undefined,
    },
  ];
};
